import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import '../../../assets/css/customer/home/WeddingProgram.css';

const WeddingProgram = () => {
   const navigate = useNavigate();
  return (
    <section className="wedding-program-section">
      <Container>
        {/* Top Description Text */}
        <p className="program-description">
          Discover how we transform dreams into reality. From intimate ceremonies to grand 
          celebrations, every moment is crafted with love and attention to detail.
        </p>

        {/* Main Heading */}
        <h2 className="program-heading">
          The Unrivaled Scenery, Unforgettable<br />
          Wedding Program
        </h2>

        {/* Images Grid */}
        <Row className="program-images-row">
          {/* Left Large Image */}
          <Col lg={7} md={12} className="program-image-col-left">
            <div className="program-image-large">
              <img 
                src="https://i.pinimg.com/736x/73/52/db/7352dbf43019238a343660b31f3b8db7.jpg" 
                alt="Beautiful Wedding Ceremony"
                className="program-img"
              />
            </div>
          </Col>

          {/* Right Small Images */}
          <Col lg={5} md={12} className="program-image-col-right">
            <div className="program-images-small">
              {/* Top Image - Wedding Rings */}
              <div className="program-image-small program-image-top">
                <img 
                  src="https://i.pinimg.com/736x/48/2c/51/482c5146d09176be20129b8bc6c4eb92.jpg" 
                  alt="Wedding Rings"
                  className="program-img"
                />
              </div>
              
              {/* Bottom Image - Bride with Bouquet */}
              <div className="program-image-small program-image-bottom">
                <img 
                  src="https://designingmedia.com/bridely/wp-content/uploads/2022/07/sec5_wine.jpg" 
                  alt="Wedding Bouquet"
                  className="program-img"
                />
              </div>
            </div>
          </Col>
        </Row>

        {/* CTA Button */}
        <div className="button-container">
              <button
               type="button"
              className="btn-make-reservation"
                 onClick={() => navigate("/events")}
  >
    Make Reservations
  </button>
</div>
      </Container>
    </section>
  );
};

export default WeddingProgram;